import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Top = styled.div`
  padding: 72px 0 40px 0;

  ${up('sm')} {
    padding: 65px 0 80px 0;
  }
`

const Suptitle = styled.h6`
  color: #0078c9;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  text-transform: uppercase;
  margin-bottom: 12px;
  text-align: center;

  ${up('sm')} {
    display: none;
  }
`

const Title = styled.h1`
  margin-bottom: 8px;
  font-size: 23px;
  font-weight: bold;
  line-height: 38px;
  text-align: center;

  ${up('sm')} {
    margin-bottom: 10px;
    font-size: 26px;
    line-height: 37px;
  }
`

const Subtitle = styled.p`
  margin: 0;
  color: #22262a;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
`

const Photo = styled.img`
  border-radius: 5px;

  ${up('sm')} {
    border-radius: 10px;
  }
`

const PhotoDescription = styled.p`
  margin: 0;
  padding: 16px 16px 0 16px;
  color: #757d88;
  font-size: 15px;

  ${up('sm')} {
    padding: 24px 24px 0 24px
    text-align: center;
  }
`

export const Intro: ComponentType = () => (
  <>
    <Container>
      <Row className="justify-content-center">
        <Col lg={6}>
          <Top>
            <Suptitle>Yucatán Premier</Suptitle>
            <Title>Asesores Certificados en Bienes Raíces</Title>
            <Subtitle>
              Somos un equipo de expertos locales comprometidos con la excelencia y atención personalizada de nuestros
              clientes. Estamos para servirte.
            </Subtitle>
          </Top>
        </Col>
      </Row>
    </Container>
    <Container>
      <Row>
        <Col>
          <Photo alt="" src="/images/staff-photo.jpg" className="img-fluid" />
          <PhotoDescription className="text-center">
            Capacitamos a todos nuestros asesores para brindar un servicio de primera calidad; profesional, personalizado
            y enfocado en encontrar el espacio ideal para tí.
          </PhotoDescription>
        </Col>
      </Row>
    </Container>
  </>
)
